import { connect } from 'react-redux';

import EndModal from './EndModal';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  config: state.config,
  status: state.user.status,
  idAyomi: state.user.projectId,
});

export default connect(mapStateToProps)(EndModal);
